"use client";
import React from "react";
import { Image } from "react-bootstrap";
import "./loginslider.css";
import BumppyEppLogo from "../Images/Logos/Bumppy-epp-logo.svg";
import chAafoLogo from "../Images/Logos/chAafo-logo.svg";
import GrownPayLogo from "../Images/Logos/Grown-Pe.svg";
import GTKLogo from "../Images/Logos/GTK Logo.svg";
import PakkyLogo from "../Images/Logos/Packky.svg";
import ShubPaisaLogo from "../Images/Logos/Shubh-Paisa-Logo.svg";
import TopAdvocacy from "../Images/Logos/Top-Advocacy.svg";
import TrawloLogo from "../Images/Logos/Trawlo-Yellow-Green.svg";
import Anlook from "../Images/Logos/Anlook.svg";
import BillPunch from "../Images/Logos/BillPuLogo.svg";
import UkoPayLogo from "../Images/Logos/UKOPAYLogo.svg";
export const logos = [
  { src: Anlook, alt: "Anlook" },
  { src: BumppyEppLogo, alt: "Bumppy EPP" },
  { src: GrownPayLogo, alt: "Grown Pay" },
  { src: BillPunch, alt: "Bill Punch" },
  { src: chAafoLogo, alt: "chAafo" },
  { src: GTKLogo, alt: "GTK" },
  { src: PakkyLogo, alt: "Pakky" },
  { src: ShubPaisaLogo, alt: "Shub Paisa" },
  { src: TopAdvocacy, alt: "Top Advocacy" },
  { src: TrawloLogo, alt: "Trawlo" },
  { src: UkoPayLogo, alt: "UKO Pay" },
];


const LogoSlider = () => {
  return (
    <div className="scroll-wrapper mb-5">
      <h2
        className="text-center m-5"
        style={{
          fontWeight: "700",
          background: "linear-gradient(90deg, #ff0080, #7928ca, #2afadf)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          letterSpacing: "1px",
        }}
      >
        Trusted by Our Valued Clients 💫
      </h2>

      <div
        style={{
          height: "4px",
          width: "70%",
          margin: "0 auto 2rem auto",
          background: "linear-gradient(90deg, #ff0080, #7928ca, #2afadf)",
          borderRadius: "2px",
        }}
      ></div>

      <div className="scroll-content mt-3">
        {[...logos, ...logos].map((logo, index) => (
          <Image
            key={index}
            className="logo-img"
            src={logo.src}
            alt={logo.alt}
            // style={imageStyle}
            style={{
              width: "200px",
              margin: "0 40px",
              objectFit: "contain",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default LogoSlider;
